import { createApiAction } from "../helpers/api";
import { action } from "./helpers";

export const FILE = {
  PUBLISH: "/FILE/PUBLISH",
  REMOVE: "/FILE/REMOVE",
};

export const FILES = {
  PUBLISH: "/FILES/PUBLISH",
  DESTROY: "/FILES/DESTROY",
};

export const FOLDERS = {
  SELECT: "FOLDERS/SELECT",
};

export const FOLDER = {
  SELECT: "FOLDER/SELECT",
};

export const publishFiles = createApiAction({
  method: "POST",
  endpoint: ({ storageDirectory = "files" }) =>
    `/api/storage/${storageDirectory}/publish`,
  baseType: FILES.PUBLISH,
});

export const destroyFile = createApiAction({
  method: "DELETE",
  endpoint: ({ storageDirectory, id }) =>
    `/api/storage/${storageDirectory}/${id}`,
  baseType: FILES.DESTROY,
});

export const selectFolder = ({ id, namespace }) =>
  action(FOLDER.SELECT, { meta: { id, namespace } });
